<div class="pricing-plans-container">
  <h2 class="title">Choose a payment plan</h2>
  <div class="carousel-viewport">
  <div class="card-carousel" [style.transform]="'translateX(-' + currentIndex() * 100 + '%)'"  (pointerdown)="start($event)" (pointerup)="end($event)">
    <mat-card class="plan-card" *ngFor="let plan of paymentPlan(); let i = index" [class.popular]="paymentPlan()?.length === 3 && !plan?.isPopular">
      <div class="plan-header">
        <span class="plan-title"></span>
        @if(plan.type === 'one_time'){
          <span class="plan-title"> Upfront</span>
        } @else if (plan.type === 'recurring' && !plan.title ){
          <span class="plan-title"> Installment plan</span>
        } @else {
          <span class="plan-title"> {{plan.title}}</span>
        }
      </div>
      <div class="plan-highlight">
        @if(plan?.isPopular){
          <mat-icon inline>star</mat-icon> Most Popular
        }

      </div>
      <div class="plan-price">
        @if(plan.type === 'one_time') {
          <span class="price"> <s>${{plan.receipt.paymentSummary.basePrice}}</s></span><br>
          <span class="price"><span class="priceColor">{{ '$' + plan.receipt.paymentSummary.total }}</span> pay once</span>
        }

        @if(plan.type === 'recurring' && plan.title !== 'T1/T2 Tuition')  {
          <span class="price"> <span class="priceColor">{{ '$' + plan.receipt.installmentSummary.total }}</span><small> per month</small></span><br>
          <span class="price"> {{plan.receipt.installmentSummary.numberOfInstallments }} Installments (<span class="priceColor">${{plan.receipt?.installmentSummary?.discountedPrice || plan.receipt?.installmentSummary?.basePrice }} </span> total) </span>
        }
        @if(plan.title === 'T1/T2 Tuition')  {
          <span class="price">TOTAL TUITION <span class="priceColor"> {{ '$' + plan.receipt.installmentSummary.fullPrice }}</span></span><br>
<!--          <span class="price"> Pay T1 {{ plan.receipt.installmentSummary.basePrice}} now over {{plan.receipt.installmentSummary.numberOfInstallments }}. Pay T2 later </span>-->
        }

      </div>
      <div class="plan-savings" *ngIf="plan.receipt?.installmentSummary?.planDiscount || plan.receipt?.paymentSummary?.oneTimeDiscount">
        <span class="savings-pill"><mat-icon inline>flash_on</mat-icon> {{ '$' + (plan.receipt?.installmentSummary?.planDiscount || plan.receipt?.paymentSummary?.oneTimeDiscount) }} savings</span>
      </div>
      <div class="plan-details">
        @if(plan.type === 'one_time') {
        <ng-container >
<!--          <div class="section-name" >{{ 'name' }}</div>-->
          <table class="details-table">
            <tr >
              <td  class="detail-label">{{ 'Base Tuition' }}</td>
              <td class="detail-value">${{ plan.receipt.paymentSummary.basePrice }}</td>
            </tr>
            <tr *ngIf="plan.receipt?.paymentSummary?.oneTimeDiscount" >
              <td  class="detail-label">Upfront Savings</td>
              <td class="detail-value">${{ plan.receipt?.paymentSummary?.oneTimeDiscount }}</td>
            </tr>

            <tr *ngIf="plan.receipt?.paymentSummary?.alumniDiscount" >
              <td  class="detail-label">Alumni Discount</td>
              <td class="detail-value">${{ plan.receipt?.paymentSummary?.alumniDiscount }}</td>
            </tr>
            @if(coupon() && coupon().priceId === plan.priceId){
              <tr >
                <td  class="detail-label">Coupon</td>
                <td class="detail-value">-${{ coupon()?.couponDiscount }}</td>
              </tr>
            }
            <tr >
              <td  class="detail-label">Subtotal</td>
              <td class="detail-value">${{ plan.receipt.paymentSummary.total }}</td>
            </tr>
          </table>
        </ng-container>
        }
        @if(plan.type === 'recurring' && plan.title !== 'T1/T2 Tuition')  {
          <ng-container >
<!--            <div class="section-name" >{{ 'name' }}</div>-->
            <table class="details-table">
              <tr >
                <td  class="detail-label">{{ 'Base Tuition' }}</td>
                <td class="detail-value">${{ plan.receipt.installmentSummary.basePrice }}</td>
              </tr>
              @if(plan.receipt?.installmentSummary?.planDiscount){
                <tr>
                  <td  class="detail-label">Savings</td>
                  <td class="detail-value">${{ plan.receipt?.installmentSummary?.planDiscount }}</td>
                </tr>
              }

              @if(coupon() && coupon().priceId === plan.priceId){
                <tr >
                  <td  class="detail-label">Coupon</td>
                  <td class="detail-value">-${{ coupon()?.couponDiscount }}</td>
                </tr>
                }
              <tr >
                <td  class="detail-label">Tuition</td>
                <td class="detail-value">${{ plan.receipt?.installmentSummary?.discountedPrice || plan.receipt?.installmentSummary?.basePrice }}</td>
              </tr>
              <tr >
                <td  class="detail-label">Installments</td>
                <td class="detail-value">{{ plan.receipt?.installmentSummary?.numberOfInstallments }}</td>
              </tr>
              <tr >
                <td  class="detail-label">Monthly Payment</td>
                <td class="detail-value">${{ plan.receipt?.installmentSummary?.installmentPrice }}</td>
              </tr>
              <tr >
                <td  class="detail-label">Due Today First month's pay </td>
                <td class="detail-value">${{ plan.receipt?.installmentSummary?.subTotal }}</td>
              </tr>
            </table>
          </ng-container>
        }
        @if(plan.title === 'T1/T2 Tuition')  {
          <ng-container >
<!--            <div class="section-name" >{{ 'name' }}</div>-->
            <table class="details-table">
<!--              <tr >-->
<!--                &lt;!&ndash;              <td  class="detail-note" colspan="2">Base Tuition</td>&ndash;&gt;-->
<!--                <td  class="detail-label">Total Tuition</td>-->
<!--                <td class="detail-value">${{ plan.receipt.installmentSummary.fullPrice }}</td>-->
<!--              </tr>-->
              <tr>
                <td class="header-label">T1</td>
              </tr>
              <tr >
                <td  class="detail-label">T1 Tuition</td>
                <td class="detail-value">${{ plan.receipt.installmentSummary.basePrice }}</td>
              </tr>
              @if(coupon() && coupon().priceId === plan.priceId){
                <tr >
                  <td  class="detail-label">Coupon</td>
                  <td class="detail-value">-${{ coupon()?.couponDiscount }}</td>
                </tr>
              }
              <tr >
                <td  class="detail-label">Installments</td>
                <td class="detail-value">{{ plan.receipt?.installmentSummary?.numberOfInstallments }}</td>
              </tr>
              <tr >
                <td  class="detail-label">Monthly Payment</td>
                <td class="detail-value">${{ plan.receipt?.installmentSummary?.installmentPrice }}</td>
              </tr>
              <tr>
                <td class="header-label">T2</td>
              </tr>
              <tr >
                <td  class="detail-label">Pay T2 After Placement </td>
              </tr>

              <tr >
                <td  class="detail-label">T2 Tuition </td>
                <td class="detail-value">${{ 6000 }}</td>
              </tr>

              <tr>
                <td class="header-label">Due Today</td>
                <td class="detail-value" style="vertical-align: bottom"><i><small>(excluding fees)</small></i></td>
              </tr>

              <tr >
                <td  class="detail-label">First month's pay </td>
                <td class="detail-value">${{ plan.receipt?.installmentSummary?.subTotal }}</td>
              </tr>
            </table>

          </ng-container>
        }
        <div style="display: flex; justify-self: flex-end">
        @if((openId !== plan.priceId )&& plan?.allowCoupons){
          <u style="cursor: pointer" (click)="toggle(plan?.priceId)">I have a promo code</u>
        }
        @if(openId === plan.priceId && plan?.allowCoupons){
          <mat-form-field appearance="outline">
            <mat-chip-grid #chipGrid aria-label="Single chip selector">

              <!-- existing chips -->
              <mat-chip-row
                *ngFor="let chip of chips"
                [removable]="true"
                (removed)="remove(chip, plan)"
              >
                {{ chip }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>

              <!-- show input only when no chip yet -->
              <input
                *ngIf="chips.length < 1"
                matInput
                placeholder="Coupon"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="add($event)"
              />
            </mat-chip-grid>
          </mat-form-field>
        }
        </div>

        <!--        <div class="extra-detail">-->
<!--          <span class="detail-label">{{ }} <small>{{  }}</small>:</span>-->
<!--          <span class="detail-value">{{  }}</span>-->
<!--        </div>-->
      </div>
      @if(plan.title === 'T1/T2 Tuition')  {
        <div class="plan-footnote" *ngIf="plan.title === 'T1/T2 Tuition'"> <span  style="color: #4bf9d8;"> The remaining 6000 for T2 will be paid after placement,
          with monthly payments according to the agreed terms.</span> Excluding credit card transaction fees</div>
      } @else {
        <div class="plan-footnote">Excluding credit card transaction fees</div>
      }

      <div class="plan-action">
        <button mat-raised-button color="primary" class="plan-button" (click)="selectPlan(plan)">Get this plan</button>
      </div>
    </mat-card>
  </div>
  </div>
  <div class="indicator-dots">
    <span *ngFor="let plan of paymentPlan(); let i = index" [class.active]="i === currentIndex()"></span>
  </div>
</div>
